<template>
    <div class="lbody">
        <img src="../assets/logo.png" width="360" height="120"  alt="Bluedio">
        <h2>{{$t("message.Welcome_to_Bluedio_mall")}}</h2>
        <div class="mm">
            <a class="wd text-dark" href="#"  @click="changeLan('cn')">中文</a>
            <a class="wd text-dark" href="#"  @click="changeLan('en')">English</a>
        </div>
    </div>
</template>

<script>
export default {
    name: "Welcome",
    methods: {
        changeLan(lan) {
            this.$i18n.locale = lan
            this.$store.state.lan = lan
            localStorage.setItem('lan', lan)
            this.toHome()
        },
         toHome() {
            this.$router.push({
                name: "enhome",
            });
        },
    }
    

};
</script>

<style scoped>
.lbody {
    margin: 0 auto;
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -55%);
    text-align: center;
}

.lbody .wd {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #fff;
    width: 100%;
    cursor: pointer;
    font-size: 1rem;
    margin-left: 0.5em;
    border: 1px solid #454545;
}

.lbody .mm .wd {
    display: inline-block;
    width: 45%;
}

.lbody h2 {
    font-size: 30px;
    font-weight: normal;
    margin-bottom: 1em;
    margin-top: 0.5em;
}
</style>

